import {
	requestMagazine as sendRequestMagazine,
} from './api'

const requestMagazine = async({ commit, state }, payload) => {
	try {
        const response = await sendRequestMagazine(payload)
        
		return response.data.data
	} catch(e) {
		console.error(e)
	}
}

export default {
	requestMagazine,
}
